'use strict';

angular.module('TurneroApp').component('coReportes', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'utilsService',
        'reportesService',
        'TurneroAppConstant',
        'centrosAtencionService',
        function (utilsService, reportesService, TurneroAppConstant, centrosAtencionService) {
            const ctrl = this;
            let errorGenerarReporte = [];

            ctrl.permisos = TurneroAppConstant.Permisos;

            ctrl.selectedReportes = [];

            ctrl.Es_SuperUsuario = '';

            ctrl.Rpt_General = false;
            ctrl.Rpt_Administrador = false;

            ctrl.Rpt_TDia, ctrl.Rpt_TAgente, ctrl.Rpt_TAgenteTelefonico, ctrl.Rpt_TAgenda, ctrl.Rpt_TTramite,
                ctrl.Rpt_TModalidad, ctrl.Rpt_TListado, ctrl.Rpt_TLstMovimientos, ctrl.Rpt_ULstSalidaEnAtencion,
                ctrl.Rpt_SEstadoCantidad, ctrl.Rpt_SEstadoTiempoEspera, ctrl.Rpt_UPorCentroAtencion, ctrl.Rpt_TLstAgendasTurnosReqReag,
                ctrl.Rpt_TPorCentro, ctrl.Rpt_TPorTramiteAgenda, ctrl.Rpt_TPorModalidadTramite, ctrl.Rpt_MUltimoMovimientoCentroAtencion,
                ctrl.Rpt_MUltimoMovimietoUsuario, ctrl.Rpt_AAgendasPorCentroEstadoVigencia, ctrl.Rpt_TAtendidosPorAgente, ctrl.Rpt_ListadoTurnosMovimientosTotal, ctrl.Rpt_ReporteVigenciaDefinicionHorariaAgendas

            ctrl.lstReportes = [
                { Id: 1, Name: 'Turnos por día (agendados y por orden de llegada)', category: 'General', limit: false },
                { Id: 2, Name: 'Turnos por día (agrupados por modalidad)', category: 'General', limit: false },
                { Id: 3, Name: 'Turnos otorgados por agente', category: 'General', limit: false },
                { Id: 4, Name: 'Turnos otorgados por agente telefonico', category: 'General', limit: false },
                { Id: 5, Name: 'Turnos otorgados por agenda', category: 'General', limit: false },
                { Id: 6, Name: 'Turnos otorgados por trámite', category: 'General', limit: false },
                { Id: 7, Name: 'Listado de Turnos', category: 'General', limit: true },
                { Id: 8, Name: 'Listado de Movimientos de Turnos', category: 'General', limit: true },
                { Id: 9, Name: 'Salidas de Usuarios', category: 'General', limit: true },
                { Id: 10, Name: 'Estado de Salón', category: 'General', limit: true },
                { Id: 11, Name: 'Estado de Salón (Tiempo de Espera)', category: 'General', limit: true },
                { Id: 12, Name: 'Cantidad de usuarios por centro de atención', category: 'S_Admin', limit: false },
                { Id: 13, Name: 'Agendas con Turnos que Requieren Reagendado', category: 'General', limit: true },
                { Id: 14, Name: 'Cantidad de turnos por centro de atención', category: 'S_Admin', limit: false },
                { Id: 15, Name: 'Cantidad de turnos por trámite', category: 'S_Admin', limit: false },
                { Id: 16, Name: 'Cantidad de turnos por modalidad y trámite', category: 'S_Admin', limit: false },
                { Id: 17, Name: 'Último movimiento de centros de atención', category: 'S_Admin', limit: false },
                { Id: 18, Name: 'Último movimiento de usuarios por centro', category: 'General', limit: true },
                { Id: 19, Name: 'Agendas por centro por estado y vigencia', category: 'S_Admin', limit: false },
                { Id: 20, Name: 'Cantidad de turnos atendidos por agente', category: 'General', limit: false },
                { Id: 21, Name: 'Listado de Movimientos de Turnos Total', category: 'S_Admin', limit: true },
                { Id: 22, Name: 'Reporte de vigencia y definición horaria de agendas', category: 'S_Admin', limit: true }
            ];

            ctrl.limpiarMemoria = function () {
                errorGenerarReporte = [];
                ctrl.Reportes = {
                    TurnosDia: null,
                    TurnosDiaModalidad: null,
                    TurnosOtorgadosAgente: null,
                    TurnosOtorgadosAgenteTelefonicos: null,
                    TurnosPorAgenda: null,
                    TurnosPorTramite: null,
                    ListadoTurnos: null,
                    ListadoTurnosMovimiento: null,
                    ListadoSalidaUsuarioEnAtencion: null,
                    EstadoSalonCantidad: null,
                    EstadoSalonTiempoEspera: null,
                    UsuarioPorCentroAtencion: null,
                    AgendasConTurnosRequiereReagendado: null,
                    TurnosPorCentroDeAtencion: null,
                    TurnosPorTramiteAgenda: null,
                    TurnosPorModalidaTramite: null,
                    UltimoMovimientoCentroAtencion: null,
                    UltimoMovimientoUsuario: null,
                    AgendasPorCentroEstadoVigencia: null,
                    TurnosAtendidosPorAgente: null,
                    ListadoTurnosMovimientosTotal: null,
                    ReporteVigenciaDefinicionHorariaAgendas: null
                };
                ctrl.loading = {
                    TurnosDia: false,
                    TurnosDiaModalidad: false,
                    TurnosOtorgadosAgente: false,
                    TurnosOtorgadosAgenteTelefonicos: false,
                    TurnosPorAgenda: false,
                    TurnosPorTramite: false,
                    TurnosListado: false,
                    TurnosListadoMovimientos: false,
                    UsuarioSalidaEnAtencionListado: false,
                    EstadoSalonCantidad: false,
                    EstadoSalonTiempoEspera: false,
                    UsuarioPorCentroAtencion: false,
                    AgendasConTurnosRequiereReagendado: false,
                    TurnosPorCentroDeAtencion: false,
                    TurnosPorTramiteAgenda: false,
                    TurnosPorModalidaTramite: false,
                    UltimoMovimientoCentroAtencion: false,
                    UltimoMovimientoUsuario: false,
                    AgendasPorCentroEstadoVigencia: false,
                    TurnosAtendidosPorAgente: false,
                    ListadoTurnosMovimientosTotal: false,
                    ReporteVigenciaDefinicionHorariaAgendas: false
                };
            };

            ctrl.$onInit = function () {
                ctrl.Reportes = null;
                ctrl.Filtro = {
                    FechaDesde: moment(),
                    FechaHasta: moment(),
                    centroSeleccionado: undefined,
                    soloCentrosActivos: 'N'
                }
                ctrl.limiteFecha();
                ctrl.filtrarCentros();
                ctrl.selectedReportes = [];
                ctrl.Es_SuperUsuario = JSON.parse(localStorage.getItem('ngStorage-TurneroApp_Authorization'));
            }

            ctrl.getLimitValueById = function (id) {
                var reporte = ctrl.lstReportes.find(function(report) {
                  return report.Id === id;
                });
                if (reporte) {
                  return reporte.limit;
                }
                return null;
            }

            ctrl.validacionReportesLimitados = function() {
                return ctrl.selectedReportes.some(rep => ctrl.getLimitValueById(rep));
              };

            ctrl.limiteFecha = function () {
               const fecha_desde = moment(ctrl.Filtro.FechaDesde);

                if (!ctrl.validacionReportesLimitados()) {
                    ctrl.Fecha_Hasta_Limite = moment(ctrl.Filtro.FechaDesde).add(365, 'day').toDate();
                    ctrl.Filtro.FechaHasta = fecha_desde;
                } else {
                    ctrl.Fecha_Hasta_Limite = moment(ctrl.Filtro.FechaDesde).add(31, 'day').toDate();
                    ctrl.Filtro.FechaHasta = fecha_desde;
                }
            };

            ctrl.filtrarCentros = function () {
                ctrl.borrarComboCentros();
                ctrl.promise = centrosAtencionService.Get_Combo_Centros_Atencion_x_Usuario({ 'Solo_Centros_Activos': ctrl.Filtro.soloCentrosActivos }).$promise.then(function (data) {
                    ctrl.centros = data.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.borrarComboCentros = function () {
                ctrl.Filtro.centroSeleccionado = undefined;
            };

            ctrl.generarReportes = async function () {

                ctrl.Rpt_General = false;
                ctrl.Rpt_Administrador = false;

                let limpiarValorCentroAtencionAlFinalizar = false;
                utilsService.swalTitle('Generando reportes', 'info');

                ctrl.Reportes = null;

                if (!ctrl.Filtro.centroSeleccionado) {
                    ctrl.Filtro.centroSeleccionado = ctrl.centroAtencionSeleccionado;
                    limpiarValorCentroAtencionAlFinalizar = true;
                }

                if (!ctrl.Filtro.FechaDesde || !ctrl.Filtro.FechaHasta || !moment(ctrl.Filtro.FechaDesde).isValid() || !moment(ctrl.Filtro.FechaHasta).isValid()) {
                    sweetAlert("Campos incompletos", 'Es necesario completar la fecha desde y la fecha hasta, para generar el reporte.', "warning");
                    return;
                }

                ctrl.limpiarMemoria();

                let filtro = {
                    Id_Centro_Atencion: ctrl.Filtro.centroSeleccionado.id,
                    FecDesde: ctrl.Filtro.FechaDesde ? moment(ctrl.Filtro.FechaDesde).format('YYYY-MM-DDT00:00:00') : null,
                    FecHasta: ctrl.Filtro.FechaHasta ? moment(ctrl.Filtro.FechaHasta).format('YYYY-MM-DDT23:59:59') : null,
                };

                ctrl.Rpt_TDia = ctrl.ReporteSeleccionado(1);
                if (ctrl.Rpt_TDia){
                    await ctrl.TurnosDia(filtro);
                }

                ctrl.Rpt_TModalidad = ctrl.ReporteSeleccionado(2);
                if (ctrl.Rpt_TModalidad){
                    await ctrl.Turnos_Por_Modalidad(filtro);
                }

                ctrl.Rpt_TAgente = ctrl.ReporteSeleccionado(3);
                if (ctrl.Rpt_TAgente){
                    await ctrl.Turnos_Por_Agente(filtro);
                }

                ctrl.Rpt_TAgenteTelefonico = ctrl.ReporteSeleccionado(4);
                if (ctrl.Rpt_TAgenteTelefonico){
                    await ctrl.Turnos_Por_Agente_Telefonico(filtro);
                }

                ctrl.Rpt_TAgenda = ctrl.ReporteSeleccionado(5);
                if (ctrl.Rpt_TAgenda){
                    await ctrl.Turnos_Por_Agenda(filtro);
                }

                ctrl.Rpt_TTramite = ctrl.ReporteSeleccionado(6);
                if (ctrl.Rpt_TTramite){
                    await ctrl.Turnos_Por_Tramite(filtro);
                }

                ctrl.Rpt_TListado = ctrl.ReporteSeleccionado(7);
                if (ctrl.Rpt_TListado)
                {
                    await ctrl.Get_Turnos_Listado(filtro);
                }

                ctrl.Rpt_TLstMovimientos = ctrl.ReporteSeleccionado(8);
                if (ctrl.Rpt_TLstMovimientos){
                    await ctrl.Get_Turnos_Listado_Movimientos(filtro);
                }

                ctrl.Rpt_ULstSalidaEnAtencion = ctrl.ReporteSeleccionado(9);
                if (ctrl.Rpt_ULstSalidaEnAtencion){
                    await ctrl.Get_Salidas_De_Atencion_X_Usuarios(filtro);
                }

                ctrl.Rpt_SEstadoCantidad = ctrl.ReporteSeleccionado(10);
                if (ctrl.Rpt_SEstadoCantidad){
                    await ctrl.Get_Estado_Salon_Cantidad(filtro);
                }

                ctrl.Rpt_SEstadoTiempoEspera = ctrl.ReporteSeleccionado(11);
                if (ctrl.Rpt_SEstadoTiempoEspera){
                    await ctrl.Get_Estado_Salon_Tiempos_Espera(filtro);
                }

                ctrl.Rpt_UPorCentroAtencion = ctrl.ReporteSeleccionado(12);
                if (ctrl.Rpt_UPorCentroAtencion){
                    await ctrl.Get_Usuarios_Centro_Atencion_Rol(filtro);
                }

                ctrl.Rpt_TLstAgendasTurnosReqReag = ctrl.ReporteSeleccionado(13);
                if (ctrl.Rpt_TLstAgendasTurnosReqReag){
                    await ctrl.Get_Agendas_Turnos_Requiere_Reagendado(filtro);
                }

                ctrl.Rpt_TPorCentro = ctrl.ReporteSeleccionado(14);
                if (ctrl.Rpt_TPorCentro){
                    await ctrl.Get_Cantidad_Turnos_Centro_Atencion_Reparticion(filtro);
                }

                ctrl.Rpt_TPorTramiteAgenda = ctrl.ReporteSeleccionado(15);
                if (ctrl.Rpt_TPorTramiteAgenda){
                    await ctrl.Get_Cantidad_Turnos_Tramite_Agenda(filtro);
                }

                ctrl.Rpt_TPorModalidadTramite = ctrl.ReporteSeleccionado(16);
                if (ctrl.Rpt_TPorModalidadTramite){
                    await ctrl.Get_Cantidad_Turnos_Modalidad_Tramite(filtro);
                }

                ctrl.Rpt_MUltimoMovimientoCentroAtencion = ctrl.ReporteSeleccionado(17);
                if (ctrl.Rpt_MUltimoMovimientoCentroAtencion){
                    await ctrl.Get_Ultimo_Movimiento_Centro_Atencion(filtro);
                }

                ctrl.Rpt_MUltimoMovimietoUsuario = ctrl.ReporteSeleccionado(18);
                if (ctrl.Rpt_MUltimoMovimietoUsuario){
                    await ctrl.Get_Ultimo_Movimiento_Usuario(filtro);
                }

                ctrl.Rpt_AAgendasPorCentroEstadoVigencia = ctrl.ReporteSeleccionado(19);
                if (ctrl.Rpt_AAgendasPorCentroEstadoVigencia){
                    await ctrl.Get_Estado_Agendas_Centro_Atencion(filtro);
                }

                ctrl.Rpt_TAtendidosPorAgente = ctrl.ReporteSeleccionado(20);
                if (ctrl.Rpt_TAtendidosPorAgente){
                    await ctrl.Get_Turnos_Atendidos_Por_Agente(filtro);
                }

                ctrl.Rpt_ListadoTurnosMovimientosTotal = ctrl.ReporteSeleccionado(21);
                if (ctrl.Rpt_ListadoTurnosMovimientosTotal){
                    await ctrl.Get_Listado_Turnos_Movimientos_Total(filtro);
                }

                ctrl.Rpt_ReporteVigenciaDefinicionHorariaAgendas = ctrl.ReporteSeleccionado(22);
                if (ctrl.Rpt_ReporteVigenciaDefinicionHorariaAgendas){
                    await ctrl.Get_Reporte_Vigencia_Definicion_Horaria_Agendas(filtro);
                }


                ctrl.Ocultar_Swal_Generar_Reporte();

                if (limpiarValorCentroAtencionAlFinalizar) {
                    ctrl.Filtro.centroSeleccionado = undefined;
                    ctrl.Filtro.soloCentrosActivos = 'N';
                }
            };


            ctrl.ReporteSeleccionado = function (idReporte) {
                var selecciono = ctrl.selectedReportes.filter(id => id == idReporte);
                return selecciono.length > 0 ? true : false;
            };

            ctrl.TurnosDia = async function (filtro) {
                ctrl.loading.TurnosDia = true;
                ctrl.Rpt_General = true;
                await reportesService.Turnos_Por_Dia({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion })
                .$promise.then(function (resultado) {
                    ctrl.Reportes.TurnosDia = resultado.Data;
                    ctrl.loading.TurnosDia = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosDia = false;
                    errorGenerarReporte.push("Turnos por dia");
                });
            };

            ctrl.Turnos_Por_Agente = async function (filtro) {
                ctrl.loading.TurnosOtorgadosAgente = true;
                ctrl.Rpt_General = true;
                await reportesService.Turnos_Por_Agente({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion, 'Es_telefonico': 0 })
                .$promise.then(function (resultado) {
                    ctrl.Reportes.TurnosOtorgadosAgente = resultado.Data;
                    ctrl.loading.TurnosOtorgadosAgente = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosOtorgadosAgente = false;
                    errorGenerarReporte.push("Turnos por agente");
                });
            };

            ctrl.Turnos_Por_Agente_Telefonico = async function (filtro) {
                ctrl.loading.TurnosOtorgadosAgenteTelefonicos = true
                ctrl.Rpt_General = true;
                await reportesService.Turnos_Por_Agente({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion, 'Es_telefonico': 1 })
                .$promise.then(function (resultado) {
                    ctrl.Reportes.TurnosOtorgadosAgenteTelefonicos = resultado.Data;
                    ctrl.loading.TurnosOtorgadosAgenteTelefonicos = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosOtorgadosAgenteTelefonicos = false;
                    errorGenerarReporte.push("Turnos por agente telefonico");
                });
            };

            ctrl.Turnos_Por_Agenda = async function (filtro) {
                ctrl.loading.TurnosPorAgenda = true;
                ctrl.Rpt_General = true;
                await reportesService.Turnos_Por_Agenda({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion })
                .$promise.then(function (resultado) {
                    ctrl.Reportes.TurnosPorAgenda = resultado.Data;
                    ctrl.loading.TurnosPorAgenda = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosPorAgenda = false;
                    errorGenerarReporte.push("Turnos por agenda");
                });
            };

            ctrl.Turnos_Por_Tramite = async function (filtro) {
                ctrl.loading.TurnosPorTramite = true;
                ctrl.Rpt_General = true;
                await reportesService.Turnos_Por_Tramite({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (resultado) {
                    ctrl.Reportes.TurnosPorTramite = resultado.Data;
                    ctrl.loading.TurnosPorTramite = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosPorTramite = false;
                    errorGenerarReporte.push("Turnos por tramite");
                });
            };

            ctrl.Turnos_Por_Modalidad = async function (filtro) {
                ctrl.loading.TurnosDiaModalidad = true;
                ctrl.Rpt_General = true;
                await reportesService.Turnos_Por_Modalidad({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (resultado) {
                    ctrl.Reportes.TurnosDiaModalidad = resultado.Data;
                    ctrl.loading.TurnosDiaModalidad = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosDiaModalidad = false;
                    errorGenerarReporte.push("Turnos por modalidad");
                });
            };

            ctrl.Get_Turnos_Listado = async function (filtro) {
                ctrl.loading.TurnosListado = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Turnos_Listado({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (resultado) {
                    ctrl.Reportes.ListadoTurnos = resultado.Data;
                    ctrl.loading.TurnosListado = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosListado = false;
                    errorGenerarReporte.push("Listado de turnos");
                });
            };

            ctrl.Get_Turnos_Listado_Movimientos = async function (filtro) {
                ctrl.loading.TurnosListadoMovimientos = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Turnos_Listado_Movimientos({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (resultado) {
                    ctrl.Reportes.ListadoTurnosMovimiento = resultado.Data;
                    ctrl.loading.TurnosListadoMovimientos = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosListadoMovimientos = false;
                    errorGenerarReporte.push("Listado de movimientos de turnos");
                });
            };

            ctrl.Get_Salidas_De_Atencion_X_Usuarios = async function (filtro) {
                ctrl.loading.UsuarioSalidaEnAtencionListado = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Salidas_De_Atencion_X_Usuarios({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (resultado) {
                    ctrl.Reportes.ListadoSalidaUsuarioEnAtencion = resultado.Data;
                    ctrl.loading.UsuarioSalidaEnAtencionListado = false;
                }).catch(function (error) {
                    ctrl.loading.UsuarioSalidaEnAtencionListado = false;
                    errorGenerarReporte.push("Salidas de usuarios");
                });
            };

            ctrl.Get_Estado_Salon_Cantidad = async function (filtro) {
                ctrl.loading.EstadoSalonCantidad = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Estado_Salon_Cantidades({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.EstadoSalonCantidad = response.Data;
                    ctrl.loading.EstadoSalonCantidad = false;
                }).catch(function (error) {
                    ctrl.loading.EstadoSalonCantidad = false;
                    errorGenerarReporte.push("Estado de salon");
                });
            };

            ctrl.Get_Estado_Salon_Tiempos_Espera = async function (filtro) {
                ctrl.loading.EstadoSalonTiempoEspera = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Estado_Salon_Tiempos_Espera({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.EstadoSalonTiempoEspera = response.Data;
                    ctrl.loading.EstadoSalonTiempoEspera = false;
                }).catch(function (error) {
                    ctrl.loading.EstadoSalonTiempoEspera = false;
                    errorGenerarReporte.push("Estado de salon - Tiempo de Espera");
                });
            };

            ctrl.Get_Usuarios_Centro_Atencion_Rol = async function (filtro) {
                ctrl.loading.UsuarioPorCentroAtencion = true;
                ctrl.Rpt_Administrador = true;
                await reportesService.Get_Usuarios_Centro_Atencion_Rol({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.UsuarioPorCentroAtencion = response.Data;
                    ctrl.loading.UsuarioPorCentroAtencion = false;
                }).catch(function (error) {
                    ctrl.loading.UsuarioPorCentroAtencion = false;
                    errorGenerarReporte.push("Cantidad de usuarios por centro de atencion");
                });
            };

            ctrl.Get_Agendas_Turnos_Requiere_Reagendado = async function (filtro) {
                ctrl.loading.AgendasConTurnosRequiereReagendado = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Agendas_Turnos_Requiere_Reagendado({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.AgendasConTurnosRequiereReagendado = response.Data;
                    ctrl.loading.AgendasConTurnosRequiereReagendado = false;
                }).catch(function (error) {
                    ctrl.loading.AgendasConTurnosRequiereReagendado = false;
                    errorGenerarReporte.push("Agendas con turnos que requieren reagendado");
                });
            };

            ctrl.Get_Cantidad_Turnos_Centro_Atencion_Reparticion = async function (filtro) {
                ctrl.loading.TurnosPorCentroDeAtencion = true;
                ctrl.Rpt_Administrador = true;
                await reportesService.Get_Cantidad_Turnos_Centro_Atencion_Reparticion({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.TurnosPorCentroDeAtencion = response.Data;
                    ctrl.loading.TurnosPorCentroDeAtencion = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosPorCentroDeAtencion = false;
                    errorGenerarReporte.push("Cantidad de turnos por centro de atencion");
                });
            };

            ctrl.Get_Cantidad_Turnos_Tramite_Agenda = async function (filtro) {
                ctrl.loading.TurnosPorTramiteAgenda = true;
                ctrl.Rpt_Administrador = true;
                await reportesService.Get_Cantidad_Turnos_Tramite_Agenda({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.TurnosPorTramiteAgenda = response.Data;
                    ctrl.loading.TurnosPorTramiteAgenda = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosPorTramiteAgenda = false;
                    errorGenerarReporte.push("Cantidad de turnos por tramite");
                });
            };

            ctrl.Get_Cantidad_Turnos_Modalidad_Tramite = async function (filtro) {
                ctrl.loading.TurnosPorModalidaTramite = true;
                ctrl.Rpt_Administrador = true;
                await reportesService.Get_Cantidad_Turnos_Modalidad_Tramite({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.TurnosPorModalidaTramite = response.Data;
                    ctrl.loading.TurnosPorModalidaTramite = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosPorModalidaTramite = false;
                    errorGenerarReporte.push("Cantidad de turnos por modalidad y tramite");
                });
            };

            ctrl.Get_Ultimo_Movimiento_Centro_Atencion = async function (filtro) {
                ctrl.loading.UltimoMovimientoCentroAtencion = true;
                ctrl.Rpt_Administrador = true;
                await reportesService.Get_Ultimo_Movimiento_Centro_Atencion({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.UltimoMovimientoCentroAtencion = response.Data;
                    ctrl.loading.UltimoMovimientoCentroAtencion = false;
                }).catch(function (error) {
                    ctrl.loading.UltimoMovimientoCentroAtencion = false;
                    errorGenerarReporte.push("Ultimo movimiento de centros de atencion");
                });
            };

            ctrl.Get_Ultimo_Movimiento_Usuario = async function (filtro) {
                ctrl.loading.UltimoMovimientoUsuario = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Ultimo_Movimiento_Usuario({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.UltimoMovimientoUsuario = response.Data;
                    ctrl.loading.UltimoMovimientoUsuario = false;
                }).catch(function (error) {
                    ctrl.loading.UltimoMovimientoUsuario = false;
                    errorGenerarReporte.push("Ultimo movimiento de usuarios por centro");
                });
            };

            ctrl.Get_Estado_Agendas_Centro_Atencion = async function (filtro) {
                ctrl.loading.AgendasPorCentroEstadoVigencia = true;
                ctrl.Rpt_Administrador = true;
                await reportesService.Get_Estado_Agendas_Centro_Atencion({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.AgendasPorCentroEstadoVigencia = response.Data;
                    ctrl.loading.AgendasPorCentroEstadoVigencia = false;
                }).catch(function (error) {
                    ctrl.loading.AgendasPorCentroEstadoVigencia = false;
                    errorGenerarReporte.push("Agendas por centro por estado y vigencia");
                });
            };

            ctrl.Get_Turnos_Atendidos_Por_Agente = async function (filtro) {
                ctrl.loading.TurnosAtendidosPorAgente = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Turnos_Atendidos_Por_Agente({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion }).$promise.then(function (response) {
                    ctrl.Reportes.TurnosAtendidosPorAgente = response.Data;
                    ctrl.loading.TurnosAtendidosPorAgente = false;
                }).catch(function (error) {
                    ctrl.loading.TurnosAtendidosPorAgente = false;
                    errorGenerarReporte.push("Cantidad de turnos atendidos por agente");
                });
            }

            ctrl.Get_Listado_Turnos_Movimientos_Total = async function (filtro) {
                ctrl.loading.ListadoTurnosMovimientosTotal = true;
                ctrl.Rpt_General = true;
                await reportesService.Get_Listado_Turnos_Movimientos_Total({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta }).$promise.then(function (resultado) {
                    ctrl.Reportes.ListadoTurnosMovimientosTotal = resultado.Data;
                    ctrl.loading.ListadoTurnosMovimientosTotal = false;
                }).catch(function (error) {
                    ctrl.loading.ListadoTurnosMovimientosTotal = false;
                    errorGenerarReporte.push("Listado de movimientos de turnos total");
                });
            }

            ctrl.Get_Reporte_Vigencia_Definicion_Horaria_Agendas = async function (filtro) {
                ctrl.loading.ReporteVigenciaDefinicionHorariaAgendas = true;
                ctrl.Rpt_Administrador = true;
                await reportesService.Get_Reporte_Vigencia_Definicion_Horaria_Agendas({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta }).$promise.then(function (resultado) {
                    ctrl.Reportes.ReporteVigenciaDefinicionHorariaAgendas = resultado.Data;
                    ctrl.loading.ReporteVigenciaDefinicionHorariaAgendas = false;
                }).catch(function (error) {
                    ctrl.loading.ReporteVigenciaDefinicionHorariaAgendas = false;
                    errorGenerarReporte.push("Reporte de vigencia y definición horaria de agendas");
                });
            }

            ctrl.Ocultar_Swal_Generar_Reporte = function () {
                if (!ctrl.loading.TurnosDia && !ctrl.loading.TurnosOtorgadosAgente && !ctrl.loading.TurnosOtorgadosAgenteTelefonicos && !ctrl.loading.TurnosPorAgenda
                    && !ctrl.loading.TurnosPorTramite && !ctrl.loading.TurnosDiaModalidad && !ctrl.loading.TurnosListado && !ctrl.loading.TurnosListadoMovimientos
                    && !ctrl.loading.UsuarioSalidaEnAtencionListado && !ctrl.loading.EstadoSalonCantidad && !ctrl.loading.EstadoSalonTiempoEspera && !ctrl.loading.UsuarioPorCentroAtencion
                    && !ctrl.loading.AgendasConTurnosRequiereReagendado && !ctrl.loading.TurnosPorCentroDeAtencion && !ctrl.loading.TurnosPorTramiteAgenda && !ctrl.loading.TurnosPorModalidaTramite
                    && !ctrl.loading.UltimoMovimientoCentroAtencion && !ctrl.loading.UltimoMovimientoUsuario && !ctrl.loading.AgendasPorCentroEstadoVigencia && !ctrl.loading.TurnosAtendidosPorAgente
                    && !ctrl.loading.ListadoTurnosMovimientosTotal && !ctrl.loading.ReporteVigenciaDefinicionHorariaAgendas)
                {
                    if (errorGenerarReporte.length === 0) {
                        swal.close();
                    } else {
                        swal.close();

                        errorGenerarReporte.join(",").replaceAll(",",", ")
                    
                        swal({
                            title: 'Reportes no generados',
                            text: errorGenerarReporte,
                            type: 'warning',
                            confirmButtonText: 'OK',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        });
                    }
                    
                }
            }

		    //EXPORTAR A EXCEL
		    ctrl.isOpen = false;
		    ctrl.selectedMode = 'md-fling';
		    ctrl.selectedDirection = 'up';

            ctrl.exportar = function (array, id_reporte) {

                let limpiarValorCentroAtencionAlFinalizar = false;
                utilsService.swalTitle('Exportando datos', 'info');

                if (!ctrl.Filtro.centroSeleccionado) {
                    ctrl.Filtro.centroSeleccionado = ctrl.centroAtencionSeleccionado;
                    limpiarValorCentroAtencionAlFinalizar = true;
                }

                const arrayObject = array;
                ctrl.arrayExport = [];
                ctrl.arrayExport[0] = ['Centro de Atención', ctrl.Filtro.centroSeleccionado.id + ' - ' + ctrl.Filtro.centroSeleccionado.text];

                const Desde = moment(ctrl.Filtro.FechaDesde).format('DD/MM/YYYY');
                const Hasta = moment(ctrl.Filtro.FechaHasta).format('DD/MM/YYYY');

                if (id_reporte === 1) {
                    ctrl.arrayExport[1] = ['FECHA	', 'TURNOS / % DEL TOTAL'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            moment(arrayObject[i].Fecha).format("DD/MM/YYYY"),
                            (arrayObject[i].Cantidad + ' / ' + arrayObject[i].Porcentaje)
                        ]
                    }

                    ctrl.ExcelTurnosDia.down([{
                        name: 'Agendas',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 2) {
                    ctrl.arrayExport[1] = ['Fecha	', 'Modalidad', 'Turnos'];
                    for ( let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            moment(arrayObject[i].Fecha).format("DD/MM/YYYY"),
                            arrayObject[i].N_Modalidad,
                            (arrayObject[i].Cantidad + ' / ' + arrayObject[i].Porcentaje)
                        ]
                    }

                    ctrl.ExcelTurnosDiaModalidad.down([{
                        name: 'Agendas',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 3) {
                    ctrl.arrayExport[1] = ['AGENTE', 'TURNOS'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].Agente,
                            (arrayObject[i].Cantidad + ' / ' + arrayObject[i].Porcentaje)
                        ]
                    }

                    ctrl.ExcelTurnosOtorgadosAgente.down([{
                        name: 'Agendas',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 4) {
                    ctrl.arrayExport[1] = ['AGENTE', 'TURNOS'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].Agente,
                            (arrayObject[i].Cantidad + ' / ' + arrayObject[i].Porcentaje)
                        ]
                    }

                    ctrl.ExcelTurnosOtorgadosAgenteTelefonicos.down([{
                        name: 'Agendas',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 5) {
                    ctrl.arrayExport[1] = ['AGENDA', 'TURNOS'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].N_Agenda,
                            (arrayObject[i].Cantidad + ' / ' + arrayObject[i].Porcentaje)
                        ]
                    }

                    ctrl.ExcelTurnosPorAgenda.down([{
                        name: 'Agendas',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 6) {
                    ctrl.arrayExport[1] = ['TRÁMITE', 'TURNOS OTORGADOS', 'TURNOS ATENDIDOS'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].Tramite,
                            (arrayObject[i].Cantidad_Turnos_Otorgados + ' / ' + arrayObject[i].Porcentaje_Turnos_Otorgados),
                            (arrayObject[i].Cantidad_Turnos_Atendidos + ' / ' + arrayObject[i].Porcentaje_Turnos_Atendidos)
                        ]
                    }

                    ctrl.ExcelTurnosPorTramite.down([{
                        name: 'Agendas',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 7) {
                    //ID_CENTRO_ATENCION; N_CENTRO_ATENCION; FECHA_TURNO; ID_AGENDA; N_AGENDA; ID_TRAMITE_RELEVADO; N_TRAMITE	ID_TURNO; N_ESTADO_TURNO;
                    //N_MODALIDAD_TURNO; HORA_ANUNCIADO; HORA_LLAMADO; HORA_ATENCION; HORA_FINALIZADO; PUESTO_ATENCION; CUIL_USUARIO_ATENCION; USUARIO_ATENCION
                    ctrl.arrayExport[0] = ['ID CENTRO ATENCION',
                        'CENTRO ATENCION',
                        'FECHA TURNO',
                        'ID AGENDA',
                        'AGENDA',
                        'ID TRAMITE RELEVADO',
                        'TRAMITE',
                        'ID TURNO',
                        'ESTADO',
                        'MODALIDAD',
                        'HORA ANUNCIADO',
                        'HORA LLAMADO',
                        'HORA ATENCION',
                        'HORA FINALIZADO',
                        'PUESTO ATENCION',
                        'CUIL USUARIO ATENCION',
                        'USUARIO ATENCION'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].Id_Centro_Atencion,
                            arrayObject[i].N_Centro_Atencion,
                            moment(arrayObject[i].Fec_Turno).format("DD/MM/YYYY HH:mm"),
                            arrayObject[i].Id_Agenda,
                            arrayObject[i].N_Agenda,
                            arrayObject[i].Id_Tramite_Relevado,
                            arrayObject[i].N_Tramite_Relevado ? arrayObject[i].N_Tramite_Relevado : '',
                            arrayObject[i].Id_Turno,
                            arrayObject[i].N_Estado_Turno,
                            arrayObject[i].N_Modalidad,
                            arrayObject[i].Hora_Anunciado,
                            arrayObject[i].Hora_Llamado,
                            arrayObject[i].Hora_Atencion,
                            arrayObject[i].Hora_Finalizado,
                            arrayObject[i].Puesto_Atencion,
                            arrayObject[i].N_Usuario,
                            arrayObject[i].Usuario_Atencion
                        ]
                    }

                    ctrl.ExcelListadoTurnos.down([{
                        name: 'Turnos_Listado',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 8) {
				    /*ID_CENTRO_ATENCION; N_CENTRO_ATENCION; FEC_SOLICITADO; FECHA_TURNO; ID_AGENDA; N_AGENDA; ID_TRAMITE_RELEVADO; N_TRAMITE; ID_TURNO; DNI;
				    ESTADO_FINAL_TURNO; ID_MOVIMIENTO_TURNO; FEC_MOVIMIENTO; HORA_MOVIMIENTO; ESTADO_MOVIMIENTO; PUESTO_ATENCION; USUARIO_ATENCION; CUIL_USUARIO_ATENCION*/
                    ctrl.arrayExport[0] = [
                        'ID CENTRO ATENCION',
                        'CENTRO ATENCION',
                        'FECHA SOLICITADO',
                        'FECHA TURNO',
                        'ID AGENDA',
                        'AGENDA',
                        'ID TRAMITE RELEVADO',
                        'TRAMITE',
                        'ID TURNO',
                        'DESTINO DERIVACION',
                        'DNI',
                        'CIUDADANO',
                        'ESTADO FINAL',
                        'ID MOVIMIENTO TURNO',
                        'FECHA MOVIMIENTO',
                        'HORA MOVIMIENTO',
                        'ESTADO MOVIMIENTO',
                        'PUESTO ATENCION',
                        'USUARIO ATENCION',
                        'CUIL USUARIO ATENCION'
                    ];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].Id_Centro_Atencion,
                            arrayObject[i].N_Centro_Atencion,
                            moment(arrayObject[i].Fec_Solicitado).format("DD/MM/YYYY HH:mm"),
                            moment(arrayObject[i].Fec_Turno).format("DD/MM/YYYY HH:mm"),
                            arrayObject[i].Id_Agenda,
                            arrayObject[i].N_Agenda,
                            arrayObject[i].Id_Tramite_Relevado,
                            arrayObject[i].N_Tramite_Relevado ? arrayObject[i].N_Tramite_Relevado : '',
                            arrayObject[i].Id_Turno,
                            arrayObject[i].Destino_Derivacion,
                            arrayObject[i].DNI,
                            arrayObject[i].N_Ciudadano,
                            arrayObject[i].Estado_Final_Turno,
                            arrayObject[i].Id_Movimiento_Turno,
                            moment(arrayObject[i].Fec_Movimiento).format("DD/MM/YYYY"),
                            arrayObject[i].Hora_Movimiento,
                            arrayObject[i].Estado_Movimiento,
                            arrayObject[i].Puesto_Atencion,
                            arrayObject[i].Usuario_Atencion,
                            arrayObject[i].N_Usuario
                        ]
                    }

                    ctrl.ExcelListadoTurnosMovimiento.down([{
                        name: 'Turnos_Listado_Movimientos',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 9) {
                    ctrl.arrayExport[0] = ['Agente', 'Fecha', 'Cantidad'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].Agente,
                            moment(arrayObject[i].Fecha).format('DD/MM/YYYY'),
                            arrayObject[i].Cantidad
                        ];
                    }

                    ctrl.ExcelListadoUsuarioXSalida.down([{
                        name: 'Salidas_De_Usuarios',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 10) {
                    ctrl.arrayExport[0] = ['FECHA', 'MIN. PUESTOS LOGUEADOS', 'MAX. PUESTOS LOGUEADOS', 'TURNOS GENERADOS', 'ATENCIONES FINALIZADAS', 'TURNOS PERDIDOS',
                        'ATENCIONES CON TURNO', 'ATENCIONES POR ORDEN DE LLEGADA', 'CANTIDAD POR PRIORIDAD'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            moment(arrayObject[i].Fecha).format('DD/MM/YYYY'),
                            arrayObject[i].Min_Puestos_Logueados,
                            arrayObject[i].Max_Puestos_Logueados,
                            arrayObject[i].Total_Turnos,
                            arrayObject[i].Cantidad_Finalizados,
                            arrayObject[i].Cantidad_Perdidos,
                            arrayObject[i].Cantidad_Agendados_Previamente,
                            arrayObject[i].Cantidad_Por_Orden_Llegada,
                            arrayObject[i].Cantidad_Por_Prioridad
                        ];
                    }

                    ctrl.ExcelEstadoSalonCantidad.down([{
                        name: 'Estado_Salon_Cantidad',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 11) {
                    ctrl.arrayExport[0] = [
                        'FECHA',
                        'TIEMPO PROMEDIO ESPERA CON TURNO',
                        'MENOR TIEMPO ESPERA CON TURNO',
                        'MAYOR TIEMPO ESPERA CON TURNO',
                        'TIEMPO PROMEDIO ESPERA SIN TURNO',
                        'MENOR TIEMPO ESPERA SIN TURNO',
                        'MAYOR TIEMPO ESPERA SIN TURNO'
                    ];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            moment(arrayObject[i].Fecha).format('DD/MM/YYYY'),
                            arrayObject[i].Tiempo_Promedio_Con_Turno,
                            arrayObject[i].Menor_Tiempo_Con_Turno,
                            arrayObject[i].Mayor_Tiempo_Con_Turno,
                            arrayObject[i].Tiempo_Promedio_Sin_Turno,
                            arrayObject[i].Menor_Tiempo_Sin_Turno,
                            arrayObject[i].Mayor_Tiempo_Sin_Turno
                        ];
                    }

                    ctrl.ExcelEstadoSalonTiempoEspera.down([{
                        name: 'Estado_Salon_Tiempo_Espera',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 12) {
                    ctrl.arrayExport[0] = [
                        'CENTRO DE ATENCION',
                        'ESTADO',
                        'ROL',
                        'CANTIDAD'
                    ];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].N_Centro_Atencion,
                            arrayObject[i].N_Estado,
                            arrayObject[i].N_Rol,
                            arrayObject[i].Cantidad_Usuarios,
                        ];
                    }

                    ctrl.ExcelUsuariosPorCentro.down([{
                        name: 'Usuario_Rol_Centro_Atencion',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 13) {
                    ctrl.arrayExport[0] = ['AGENDA', 'CANTIDAD TURNOS "REQ. REAG."'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].N_Agenda,
                            arrayObject[i].Cantidad_Turnos
                        ];
                    }

                    ctrl.ExcelAgendasConTurnosRequiereReagendado.down([{
                        name: 'Agenda_Turnos_Requiere_Reagendado',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 14) {

                    ctrl.arrayExport[0] = [`${Desde} - ${Hasta}`];
                    ctrl.arrayExport[1] = ['CENTRO DE ATENCION', 'REPARTICIÓN', 'CANT. TURNOS FINALIZADOS', 'CANT. TURNOS CANCELADOS', 'CANT. TURNOS PERDIDOS', 'CANT. TURNOS AGENDADOS (TOTALES)'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].N_Centro_Atencion,
                            arrayObject[i].N_Reparticion,
                            arrayObject[i].Cantidad_Turnos_Finalizados,
                            arrayObject[i].Cantidad_Turnos_Cancelados,
                            arrayObject[i].Cantidad_Turnos_Perdidos,
                            arrayObject[i].Cantidad_Turnos_Agendados
                        ];
                    }

                    ctrl.ExcelTurnosPorCentroDeAtencion.down([{
                        name: 'Turnos_Por_Centro_De_Atencion',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 15) {
                    ctrl.arrayExport[0] = [`${Desde} - ${Hasta}`];
                    ctrl.arrayExport[1] = ['TRAMITE/AGENDA', 'CANT. TURNOS AGENDADOS', 'CANT. TURNOS ATENDIDOS'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].N_Tramite,
                            arrayObject[i].Cantidad_Turnos_Agendados,
                            arrayObject[i].Cantidad_Turnos_Atendidos
                        ];
                    }

                    ctrl.ExcelTurnosPorTramiteAgenda.down([{
                        name: 'Turnos_Por_Tramite_Agenda',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 16) {
                    ctrl.arrayExport[0] = [`${Desde} - ${Hasta}`];
                    ctrl.arrayExport[1] = ['CENTRO DE ATENCIÓN', 'TRAMITE', 'CANT. PRESENCIAL', 'CANT. TÉLEFONICA', 'CANT. ONLINE', 'CANT. ORDEN DE LLEGADA'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].N_Centro_Atencion,
                            arrayObject[i].N_Tramite,
                            arrayObject[i].Cantidad_Turnos_Presencial,
                            arrayObject[i].Cantidad_Turnos_Telefonico,
                            arrayObject[i].Cantidad_Turnos_Online,
                            arrayObject[i].Cantidad_Turnos_Orden_Llegada
                        ];
                    }

                    ctrl.ExcelTurnosPorModalidadTramite.down([{
                        name: 'Turnos_Por_Modalidad_Tramite',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 17) {
                    ctrl.arrayExport[0] = ['CENTRO DE ATENCIÓN', 'FECHA ÚLTIMO MOVIMIENTO', 'CANT. DÍAS ÚLTIMO MOVIMIENTO'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].N_Centro_Atencion,
                            moment(arrayObject[i].Fecha_Ultimo_Movimiento).format('DD/MM/YYYY'),
                            arrayObject[i].Cantidad_Dias_Ultimo_Movimiento,
                        ];
                    }

                    ctrl.ExcelUltimoMovimientoCentroAtencion.down([{
                        name: 'Ultimo_Movimiento_De_Centros_De_Atencion',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 18) {
                    ctrl.arrayExport[0] = [`Centro de Atención: ${ctrl.Filtro.centroSeleccionado.text}`];
                    ctrl.arrayExport[1] = ['EMPLEADO', 'FECHA ÚLTIMO MOVIMIENTO', 'CANT. DÍAS ÚLTIMO MOVIMIENTO'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].N_Usuario,
                            moment(arrayObject[i].Fecha_Ultimo_Movimiento).format('DD/MM/YYYY'),
                            arrayObject[i].Cantidad_Dias_Ultimo_Movimiento,
                        ];
                    }

                    ctrl.ExcelUltimoMovimientoUsuario.down([{
                        name: 'Ultimo_Movimiento_De_Usuarios_Por_Centro',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 19) {
                    ctrl.arrayExport[0] = ['CENTRO DE ATENCIÓN',
                        'CANT. AGENDAS HABILITADAS',
                        'CANT. AGENDAS INHABILITADAS',
                        'CANT. AGENDAS ELIMINADAS',
                        'CANT. AGENDAS PENDIENTES',
                        'CANT. AGENDAS VIGENTES',
                        'CANT. AGENDAS NO VIGENTES',
                        'CANT. AGENDAS VENCIDAS'];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].N_Centro_Atencion,
                            arrayObject[i].Cantidad_Agendas_Habilitadas,
                            arrayObject[i].Cantidad_Agendas_Inhabilitadas,
                            arrayObject[i].Cantidad_Agendas_Eliminadas,
                            arrayObject[i].Cantidad_Agendas_Pendientes,
                            arrayObject[i].Cantidad_Agendas_Vigentes,
                            arrayObject[i].Cantidad_Agendas_No_Vigentes,
                            arrayObject[i].Cantidad_Agendas_Vencidas
                        ];
                    }

                    ctrl.ExcelAgendasPorCentroEstadoVigencia.down([{
                        name: 'Agendas_Por_Centro_Estado_Vigencia',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 20) {
                    ctrl.arrayExport[0] = [`${Desde} - ${Hasta}`, `Centro de Atención: ${ctrl.Filtro.centroSeleccionado.text}`];
                    ctrl.arrayExport[1] = ['AGENTE',
                        'CANT. TOTAL DE TURNOS ATENDIDOS',
                        'CANT. DÍAS DE ATENCIÓN',
                        'CANT. PROMEDIO DE TURNOS ATENTIDOS POR DÍA',
                        'CANT. MAXIMA DE TURNOS ATENDIDOS POR DÍA',
                        'CANT. MINIMA DE TURNOS ATENDIDOS POR DÍA'
                    ];

                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 2] = [
                            arrayObject[i].N_Agente,
                            arrayObject[i].Cantidad_Turnos_Atendidos,
                            arrayObject[i].Cantidad_Dias_Atencion,
                            arrayObject[i].Cantidad_Prom_Turnos_Atendidos,
                            arrayObject[i].Cantidad_Max_Turnos_Atendidos,
                            arrayObject[i].Cantidad_Min_Turnos_Atendidos
                        ];
                    }

                    ctrl.ExcelTurnosAtendidosPorAgentes.down([{
                        name: 'Turnos_Atendidos_Por_Agente',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 21) {
                    ctrl.arrayExport[0] = [
                        // 'ID CENTRO ATENCION',
                        'CENTRO ATENCION',
                        // 'FECHA SOLICITADO',
                        'FECHA TURNO',
                        // 'ID AGENDA',
                        'AGENDA',
                        // 'ID TRAMITE RELEVADO',
                        'TRAMITE',
                        // 'ID TURNO',
                        // 'DESTINO DERIVACION',
                        // 'DNI',
                        // 'CIUDADANO',
                        'ESTADO FINAL',
                        // 'ID MOVIMIENTO TURNO',
                        'FECHA MOVIMIENTO',
                        // 'HORA MOVIMIENTO',
                        'ESTADO MOVIMIENTO',
                        // 'PUESTO ATENCION',
                        'USUARIO ATENCION',
                        'CUIL USUARIO ATENCION'
                    ];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            // arrayObject[i].Id_Centro_Atencion,
                            arrayObject[i].N_Centro_Atencion,
                            // moment(arrayObject[i].Fec_Solicitado).format("DD/MM/YYYY HH:mm"),
                            moment(arrayObject[i].Fec_Turno).format("DD/MM/YYYY HH:mm"),
                            // arrayObject[i].Id_Agenda,
                            arrayObject[i].N_Agenda,
                            // arrayObject[i].Id_Tramite_Relevado,
                            arrayObject[i].N_Tramite_Relevado ? arrayObject[i].N_Tramite_Relevado : '',
                            // arrayObject[i].Id_Turno,
                            // arrayObject[i].Destino_Derivacion,
                            // arrayObject[i].DNI,
                            // arrayObject[i].N_Ciudadano,
                            arrayObject[i].Estado_Final_Turno,
                            // arrayObject[i].Id_Movimiento_Turno,
                            moment(arrayObject[i].Fec_Movimiento).format("DD/MM/YYYY"),
                            // arrayObject[i].Hora_Movimiento,
                            arrayObject[i].Estado_Movimiento,
                            // arrayObject[i].Puesto_Atencion,
                            arrayObject[i].Usuario_Atencion,
                            arrayObject[i].N_Usuario
                        ];
                    }

                    ctrl.ExcelListadoTurnosMovimientosTotal.down([{
                        name: 'Listado_Turnos_Movimientos_Total',
                        data: ctrl.arrayExport
                    }]);
                } else if (id_reporte === 22) {
                    ctrl.arrayExport[0] = [
                        'ID AGENDA',
                        'AGENDA',
                        'ID CENTRO ATENCION',
                        'CENTRO ATENCION',
                        'FECHA DESDE',
                        'FECHA HASTA',
                        'CANTIDAD TURNOS PERSONA',
                        'MAXIMO TURNOS ONLINE',
                        'MAXIMO TURNOS DIAS',
                        'DIAS SELECCIONADOS',
                        'CANTIDAD PUESTOS',
                        'HORA DESDE',
                        'HORA HASTA',
                        'CANTIDAD TURNOS',
                        'PRESENCIAL',
                        'ONLINE',
                        'TELEFONICA',
                        'ORDEN DE LLEGADA'
                    ];
                    for (let i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].IdAgenda,
                            arrayObject[i].NombreAgenda,
                            arrayObject[i].IdCentroAtencion,
                            arrayObject[i].NombreCentroAtencion,
                            moment(arrayObject[i].FechaDesde).format("DD/MM/YYYY"),
                            moment(arrayObject[i].FechaHasta).format("DD/MM/YYYY"),
                            arrayObject[i].CantidadTurnosPersona,
                            arrayObject[i].MaximoTurnosOnline,
                            arrayObject[i].MaximoTurnosDias,
                            arrayObject[i].DiasSeleccionados,
                            arrayObject[i].CantidadPuestos,
                            arrayObject[i].HoraDesde,
                            arrayObject[i].HoraHasta,
                            arrayObject[i].CantidadTurnos,
                            arrayObject[i].Presencial,
                            arrayObject[i].Online,
                            arrayObject[i].Telefonica,
                            arrayObject[i].OrdenLlegada
                        ];
                    }

                    ctrl.ExcelReporteVigenciaDefinicionHorariaAgendas.down([{
                        name: 'Reporte_Vigencia_Definicion_Horaria_Agendas',
                        data: ctrl.arrayExport
                    }]);
                }

                if (limpiarValorCentroAtencionAlFinalizar) {
                    ctrl.Filtro.centroSeleccionado = undefined;
                }

			    swal.close();
		    };
		    ctrl.ExcelTurnosDia = {
			    down: function () {
			    },
            };
		    ctrl.ExcelTurnosPorTramite = {
			    down: function () {
			    },
            };
		    ctrl.ExcelTurnosPorAgenda = {
			    down: function () {
			    },
            };
		    ctrl.ExcelTurnosOtorgadosAgenteTelefonicos = {
			    down: function () {
			    },
		    };
		    ctrl.ExcelTurnosOtorgadosAgente = {
			    down: function () {
			    },
		    };
		    ctrl.ExcelTurnosDiaModalidad = {
			    down: function () {
			    },
		    };
		    ctrl.ExcelListadoTurnos = {
			    down: function () {
			    },
		    };
		    ctrl.ExcelListadoTurnosMovimiento = {
			    down: function () {
			    },
            };
            ctrl.ExcelListadoUsuarioXSalida = {
                down: function () {
                }
            };
            ctrl.ExcelEstadoSalonCantidad = {
                down: function () {
                }
            };
            ctrl.ExcelEstadoSalonTiempoEspera = {
                down: function () {
                }
            };
            ctrl.ExcelUsuariosPorCentro = {
                down: function () {
                }
            };
            ctrl.ExcelAgendasConTurnosRequiereReagendado = {
                down: function () {
                }
            };
            ctrl.ExcelTurnosPorCentroDeAtencion = {
                down: function () {
                }
            };
            ctrl.ExcelTurnosPorTramiteAgenda = {
                down: function () {
                }
            };
            ctrl.ExcelTurnosPorModalidadTramite = {
                down: function () {
                }
            };
            ctrl.ExcelUltimoMovimientoCentroAtencion = {
                down: function () {
                }
            };
            ctrl.ExcelUltimoMovimientoUsuario = {
                down: function () {
                }
            };
            ctrl.ExcelAgendasPorCentroEstadoVigencia = {
                down: function () {
                }
            };
            ctrl.ExcelTurnosAtendidosPorAgentes = {
                down: function () {
                }
            };
            ctrl.ExcelListadoTurnosMovimientosTotal = {
			    down: function () {
			    },
            };
            ctrl.ExcelReporteVigenciaDefinicionHorariaAgendas = {
                down: function () {
                },
            };
	    }
	],
	template: require('./reportes.html')
});



// WEBPACK FOOTER //
// ./app/components/reportes/reportesComponent.js